<template>
    <div class="orderlistcont1">
      <top-nav1 ref="TopNav1"></top-nav1>
      <div class="pop" v-if="lodingshow"> <van-loading type="spinner" /></div>
      <van-nav-bar style="background: #F1F1F1"  title="我的订单" fixed left-arrow @click-left="goBack" >
        <van-icon slot="right" @click="onClickRight()" class="iconfont icon-zhankai"></van-icon>
      </van-nav-bar>
      <div  class="van-content" style="padding-top: 56px">
        <div id="orderList">
          <div class="nodata text-cent" v-if="noorder==true">
            <img src="./../../assets/img/dd-null.png"/>
            <span class="text">还没有相关订单~</span>
          </div>
          <van-cell-group v-if="noorder==false"  style="margin-bottom: 0" >
              <div class="van-cell">
                <div @click="godetail(orderinfo.id_order)" class="van-cell__title noborder tts">
                  <span>订单编号：{{ orderinfo.ordersn }}</span>
                  <span v-if="orderinfo.status==1" class="float-right theme-col" >待发货</span>
                  <span v-if="orderinfo.status==2" class="float-right theme-col" >已发货</span>
                  <span v-if="orderinfo.status==3" class="float-right theme-col" >已取消</span>
                </div>
              </div>
              <van-card style="background: #fafafa;margin: 0;padding: 8px 15px 8px 10px;" class="van-cell van-hairline goodsonelist" >
                <router-link slot="thumb" class="goodsimgbox"  :to="{path:'/eorder',query:{id:orderinfo.id_order,gid:gid}}">
                  <img style="border-radius:6px" :src="goodinfo.image" onerror="src='/static/errorimg1.png'">
                </router-link>
                <div @click="godetail(orderinfo.id_order)" style="margin-top: 5px;height: 40px" slot="title" class="van-card-title">
                  <div class="ellipseal">
                    <!--<span class=" radius theme-bg theme-bd  " v-if="goodinfo.source == 4">一乡一物</span>-->
                    <!--<span class="  radius theme-hot " v-if="goodinfo.source == 3">卡券</span>-->
                    <!--<span class="  radius theme-bg theme-bd " v-if="goodinfo.source == 2">直充</span>-->
                    <span class="jd1 " v-if="goodinfo.source == 1">优选</span>
                    <span class="yx1" v-if="goodinfo.source == 6">严选</span>
                    <span class=" ft15">{{ goodinfo.name }}</span>
                  </div>
                </div>
                <div slot="desc" class="van-card-desc "><span class="float-right" style="color: #A6AAB7">× {{goodinfo.number}}</span></div>
              </van-card>
              <div class="van-cell txt-right">
                <div class="van-cell__title text-right" style="text-align:rignt">
                  <div style="margin-top: 5px">
                    <router-link  :to="{name:'Eorder',query:{id:orderinfo.id_order,gid:gid}}">
                      <van-button class="radius4 theme-col  tcl" size="small">查看详情</van-button>
                    </router-link>
                  </div>
                </div>
              </div>
              <div style="padding: 0 15px">
                <img src="/static/images/eline.png" alt="">
              </div>
            </van-cell-group>

            <div v-if="!loading && goodinfo != ''" class="nomore">
              <div  class="theEnd1 ft12">
                没有更多了
              </div>
            </div>
        </div>
      </div>
      <!--底部导航-->
      <footer-nav1></footer-nav1>
    </div>
</template>
<script>
import FooterNav1 from "../../components/footernav1";
import TopNav1 from "../../components/topnav1";
export default {
  name: "orderlist",
  data() {
    return {
      goodinfo: "",
      orderinfo: "",
      page: 0,
      finished: false,
      loading: false,
      lodingshow: true,
      noorder: false,
      gid: this.$route.query.gid
    };
  },
  components: {
    FooterNav1,
    TopNav1
  },
  computed: {},
  methods: {
    godetail: function(id) {
      this.$router.push({ name: "Eorder", query: { id: id, gid: this.gid } });
    },
    goBack: function() {
      history.back(-1);
    },
    onClickRight() {
      this.$refs.TopNav1.topnavPlay();
    },
    getDatas: function() {
      var isUser = localStorage.getItem("ECuser");
      var mallid = localStorage.getItem("mallid");
      var gid = localStorage.getItem("gid");
      this.$api.get(
        "active/order",
        { id_active: this.gid, token_user: isUser },
        res => {
          if (res.data.code == "100") {
            if (res.data.data.length == 0) {
              this.noorder = true;
              this.lodingshow = false;
            } else {
              this.goodinfo = res.data.data.products;
              this.orderinfo = res.data.data.data;
              this.lodingshow = false;
            }
          } else {
            if (res.data.message == "token验证失败") {
              this.$dialog
                .confirm({
                  title: "提示 ",
                  message: "您还未登录是否去登录？"
                })
                .then(() => {
                  this.$router.push({
                    name: "Elogin",
                    query: { gid: this.gid }
                  });
                })
                .catch(() => {});
            }
            //              else{
            //                this.$toast(res.data.message);
            //              }
          }
        },
        err => {
          this.$toast("服务器繁忙，请稍后再试");
        }
      );
    },
    //去支付
    payOrder: function(id) {
      var isUser = localStorage.getItem("ECuser");
      var mallid = localStorage.getItem("mallid");
      var gid = localStorage.getItem("gid");
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定提交订单，订单提交成功不可取消"
        })
        .then(() => {
          this.pay(res.data.data.id_order);
        })
        .catch(() => {
          this.$api.post(
            "active/order/pay",
            { id_active: this.gid, token_user: isUser, id_order: id },
            res => {
              if (res.data.code == "100") {
                this.$router.push({
                  name: "Eordersucceed",
                  query: { orderId: id, gid: this.gid }
                });
              } else {
                if (res.data.message == "token验证失败") {
                  this.$dialog
                    .confirm({
                      title: "提示 ",
                      message: "您还未登录是否去登录？"
                    })
                    .then(() => {
                      this.$router.push({
                        name: "Elogin",
                        query: { gid: this.gid }
                      });
                    })
                    .catch(() => {});
                } else {
                  this.$toast(res.data.message);
                }
              }
            },
            err => {
              this.$toast("服务器繁忙，请稍后再试");
            }
          );
        });
    }
  },
  mounted() {
    this.getDatas();
    $("body").css("background", "#fff");
  },
  destroyed: function() {
    $("body").css("background", "#EFF3F6");
  }
};
</script>
<style  lang="less" >
.orderlistcont1 {
  .tts {
    display: flex;
    justify-content: space-between;
    span:first-child {
      font-size: 0.28rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 0.4rem;
    }
  }
  // .van-button__content {
  //   color: red !important;
  // }
  .tcl {
    width: 1.52rem !important;
    height: 0.62rem !important;
    border-radius: 5px;
    border: 1px solid #c4c4c4;
    box-sizing: border-box;
    line-height: 0.62rem;
    .van-button__content {
      font-size: 0.16rem !important;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
  }
  .txt-right {
    text-align: right;
    padding-top: 0px;
  }
  img {
    width: 100%;
    height: auto;
  }
  .van-card__header {
    width: 100%;
  }
  .pop {
    background-color: #fff !important;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    .van-loading {
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -15px 0 0 -15px;
    }
  }
  .van-hairline--top-bottom::after {
    border-width: 0px !important;
  }
  .van-hairline--bottom.van-nav-bar.van-nav-bar--fixed {
    .van-nav-bar__title {
      text-align: center !important;
      font-weight: bold !important;
    }
  }
  #orderList .van-button--small {
    padding: 0 15px;
    min-width: 80px;
  }
  #orderList .goodsonelist {
    /*background:#FAFAFA!important;*/
    background: #fff !important;
  }
  #orderList .van-cell:not(:last-child)::after {
    border-bottom: 0;
  }
  #orderList .goodsonelist {
    margin-bottom: 0 !important;
  }
  #orderList .goodsonelist:not(:last-child)::after {
    border-bottom: 0px solid #eee;
  }
  #orderList .van-button--default {
    color: #323233;
    background-color: #fff;
    border: 1px solid #999;
  }
  .van-nav-bar {
    .van-icon {
      font-size: 0.4rem !important;
    }
  }
  .nomore {
    .theEnd1 {
      position: relative;
      margin: 15px 0;
      color: #c1c1c1;
    }
    .theEnd1:before {
      content: "";
      position: absolute;
      width: 50px;
      height: 1px;
      background-color: #dadada;
      left: 23%;
      top: 9px;
    }
    .theEnd1:after {
      content: "";
      position: absolute;
      width: 50px;
      height: 1px;
      background-color: #dadada;
      right: 23%;
      top: 9px;
    }
    padding: 0 !important;
    background-color: inherit;
    .leftIn1 {
      font-size: 0.24rem;
      margin-bottom: 20px;
      color: #8c8c8c;
    }
    .leftIn {
      font-size: 0.24rem;

      span {
        font-size: 0.28rem;
      }
    }
  }
}

.radius4 {
  border-radius: 4px !important;
}
.theme-bd,
.van-checkbox--checked {
  border-color: red !important;
}
.theme-bg,
.van-checkbox--checked,
.van-swipe__indicator--active {
  background-color: red !important;
  color: #ffffff !important;
}
.theme-col,
.van-icon-checked {
  color: red !important;
}
.col-hover:hover {
  color: red !important;
}
.col-on {
  color: red !important;
}
.col-focus:focus {
  color: red !important;
}
.col-checked:checked:before {
  color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/exchange/orderlist.vue